"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StripesTheme = StripesTheme;
exports.StripesThemeContext = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Theme = require('./baseTheme');

var StripesThemeContext = _react["default"].createContext({}); //TODO: Add proxima nova (proxima-nova)


exports.StripesThemeContext = StripesThemeContext;

function StripesTheme(props) {
  var theme = props.theme ? props.theme : {};
  var basePalette = Theme.palette,
      baseSpacing = Theme.spacing;
  theme.palette = Object.assign(basePalette, theme && theme.palette ? theme.palette : {});
  theme.spacing = Object.assign(baseSpacing, theme && theme.spacing ? theme.spacing : {});
  theme.icons = theme ? theme.icons : null;

  if (theme.icons) {
    var iconNode = document.createElement("div");
    iconNode.setAttribute("style", "height: 0; width: 0; position: absolute; display: none;");
    iconNode.innerHTML = theme.icons;
    document.body.appendChild(iconNode);
  }

  var getColors = function getColors() {
    return theme.palette;
  };

  var getSpacing = function getSpacing() {
    return theme.spacing;
  };

  var getFont = function getFont() {
    return Theme.fontFamily;
  };
  /*
      TODO: right now this is a very rudimentary context composition, will need to clean this up.
   */


  return /*#__PURE__*/_react["default"].createElement(StripesThemeContext.Provider, {
    value: {
      theme: theme,
      getColors: getColors,
      getSpacing: getSpacing,
      getFont: getFont
    }
  }, props.children);
}